/**
 * @module tracking/trackerConstants
 * CDN constants shared by the main-thread HandTracker and the worker.
 *
 * IMPORTANT — versions must match:
 *   WASM_BASE must be pinned to the SAME minor version as the installed
 *   @mediapipe/tasks-vision npm package (currently 0.10.35). Using the
 *   WASM binary from 0.10.21 with the JS API from 0.10.35 (or vice-versa)
 *   causes silent MediaPipe graph-state corruption that produces wrong
 *   results or permanent INVALID_ARGUMENT errors on every frame.
 *
 *   When upgrading @mediapipe/tasks-vision, update the version here too.
 */

/**
 * CDN base path for the MediaPipe WASM runtime files.
 * Must match the installed npm package version exactly.
 */
export const WASM_BASE =
  'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/wasm';

/**
 * Hosted model file for HandLandmarker (float16, version 1).
 * Fetched once; cached by the browser thereafter.
 */
export const MODEL_URL =
  'https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task';
